import { action, computed } from "mobx";
import * as DocumentManagement from "../DocumentManagement";
import { InputType } from "../Shared";
import { Strings } from "../Stores/StringsStore";
import * as Utilities from "../Utilities";
import { AppStore, IWizardStore, WizardStore } from "./AppStore";
import { DocumentStoreImpl } from "./DocumentStore";


export class DocumentMetaDataSelectDocumentsWizardStore extends WizardStore implements IWizardStore {

	constructor(public documentStore: DocumentStoreImpl) {
		super();
		let uiLang = Utilities.getUiLanguage();
		if (!uiLang) {
			uiLang = AppStore.context.userInterfaceLanguages[0].name;
		}
		this.language = uiLang;
	}

	language: string;

	/**
  * Open the wizard for adding meta data.
  */
	open = (): void => {
		this.wizardCaption = Strings.documentManagement.documentEdit.addMetaDataDocumentLinkCaption;
		this.wizardInformation = Strings.documentManagement.documentEdit.addMetaDataDocumentLinkText;
		this.isOpen = true;
	}

	onConfirmExternal = () => {

	}

	/**
   * Callback for confirming the wizard operation.
   */
	@action onConfirmWizard = () => {
		this.isOpen = false;
		if (this.documentStore.existingDocumentLinkMetaValue) {
			this.documentStore.existingDocumentLinkMetaValue.valueDocumentLink.value = this.documentStore.addedDocuments[0];
			this.documentStore.existingDocumentLinkMetaValue.isValid = this.documentStore.existingDocumentLinkMetaValue.valueDocumentLink.isValid = true;
			this.documentStore.existingDocumentLinkMetaValue.validationMessage = this.documentStore.existingDocumentLinkMetaValue.valueDocumentLink.validationMessage = null;
			this.documentStore.existingDocumentLinkMetaValue = null;
			this.documentStore.addedDocuments.shift();
		}
		for (let i = 0; i < this.documentStore.addedDocuments.length; i++) {
			let value = new DocumentManagement.DocumentMetaValue();
			value.valueDocumentLink = new DocumentManagement.InputDocumentLink();
			value.valueDocumentLink.value = this.documentStore.addedDocuments[i];
			value.isValid = value.valueDocumentLink.isValid = true;
			value.validationMessage = value.valueDocumentLink.validationMessage = null;
			this.documentStore.model.metas.find(m => m.inputType === InputType.InputDocumentLink).values.push(value);
		}
		this.documentStore.selectedDocuments.push(...this.documentStore.addedDocuments);
		this.documentStore.addedDocuments.clear();
		this.onConfirmExternal();
	}

	/**
	* Callback fro canceling the wizard operation.
	*/
	@action onCancelWizard = () => {
		this.isOpen = false;
		this.documentStore.addedDocuments.clear();
	}

}